import { LOAN_REQUEST_OFFER_SOURCES } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetAcceptedOffers } from 'cpool-tables/backend-resolvers';

export type AcceptedOffer = SchemaLoanRequestResolver_GetAcceptedOffers[number];

export type ManualAcceptedOffer = Extract<AcceptedOffer, { source: typeof LOAN_REQUEST_OFFER_SOURCES.MANUAL }>;

export const isManualAcceptedOffer = (offer: AcceptedOffer): offer is ManualAcceptedOffer =>
    offer.source === LOAN_REQUEST_OFFER_SOURCES.MANUAL;

export type EuropaceAcceptedOffer = Extract<
    AcceptedOffer,
    { source: typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE | typeof LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC }
>;

export const isEuropaceOffer = (offer: AcceptedOffer): offer is EuropaceAcceptedOffer =>
    offer.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE || offer.source === LOAN_REQUEST_OFFER_SOURCES.EUROPACE_SYNC;
